import { render, staticRenderFns } from "./XlsxExport.vue?vue&type=template&id=939aa49a&"
import script from "./XlsxExport.vue?vue&type=script&lang=js&"
export * from "./XlsxExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports